import { useTranslation } from "react-i18next";
import GetInTouch from "../../../components/GetInTouch";

const CommunityGuidelinesPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="grid grid-cols-12 text-dark pb-24 max-sm:px-6 max-sm:grid-cols-1 max-sm:pb-12 bg-disabled-5">
        <h1 className="text-heading-h1 col-start-2 col-end-11 pt-24 pb-12 max-sm:pt-12 max-sm:text-mobile-heading-h1">{t("community_guidelines.title")}</h1>
        <div className="grid gap-6 col-start-3 col-end-11 pl-20 max-sm:pl-0">
          
          <div>
            <h3 className="text-heading-h3 max-sm:text-mobile-heading-h3">{t("community_guidelines.section1-title")}</h3>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section1-description-11")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section2-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section2-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section2-description-21")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section2-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section2-description-22")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section3-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section3-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section3-description-31")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section3-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section3-description-32")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section4-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section4-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section4-description-41")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section4-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section4-description-42")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section5-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section5-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section5-description-51")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section5-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section5-description-52")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section6-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section6-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section6-description-61")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section6-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section6-description-62")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section7-title")}</h4>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section7-subtitle1")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section7-description-71")}</p>
            <h5 className="text-heading-h5 pt-3 max-sm:text-mobile-heading-h5">{t("community_guidelines.section7-subtitle2")}</h5>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section7-description-72")}</p>
          </div>

          <div>
            <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.section8-title")}</h4>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.section8-description-81")}</p>
          </div>


          <div>
          <h4 className="text-heading-h4 max-sm:text-mobile-heading-h4">{t("community_guidelines.thanks")}</h4>
            <p className="text-body-m-400 pt-3 max-sm:text-mobile-body-m-400">{t("community_guidelines.always_consult")}</p>
          </div>

        </div>
      </div>
      <a id="contact"/>
      <GetInTouch />
    </>
  );
}

export default CommunityGuidelinesPage;